import {
  __name
} from "../../chunk-7QVYU63E.js";
import z from "zod";
var Chain = /* @__PURE__ */ function(Chain2) {
  Chain2["ETH"] = "eth";
  Chain2["ARB"] = "arb";
  Chain2["FLOW"] = "flow";
  Chain2["MATIC"] = "matic";
  Chain2["OPT"] = "opt";
  Chain2["SOLANA"] = "solana";
  Chain2["ASTAR"] = "astar";
  Chain2["POLYGONZKEVM"] = "polygonzkevm";
  Chain2["STARKNET"] = "starknet";
  Chain2["BASE"] = "base";
  Chain2["ZKSYNC"] = "zksync";
  Chain2["ZORA"] = "zora";
  Chain2["FRAX"] = "frax";
  Chain2["BNB"] = "bnb";
  Chain2["AVAX"] = "avax";
  Chain2["ARBNOVA"] = "arbnova";
  Chain2["ALCHEMY"] = "alchemy";
  Chain2["WORLDCHAIN"] = "worldchain";
  Chain2["ZETACHAIN"] = "zetachain";
  Chain2["BLAST"] = "blast";
  Chain2["SCROLL"] = "scroll";
  Chain2["LINEA"] = "linea";
  Chain2["GNOSIS"] = "gnosis";
  Chain2["FANTOM"] = "fantom";
  Chain2["MANTLE"] = "mantle";
  Chain2["CELO"] = "celo";
  Chain2["BERACHAIN"] = "berachain";
  Chain2["METIS"] = "metis";
  Chain2["OPBNB"] = "opbnb";
  Chain2["POLYNOMIAL"] = "polynomial";
  Chain2["SHAPE"] = "shape";
  Chain2["BOB"] = "bob";
  Chain2["CROSSFI"] = "crossfi";
  Chain2["IOTA"] = "iota";
  Chain2["MODE"] = "mode";
  Chain2["MOONBASE"] = "moonbase";
  Chain2["MOONBEAM"] = "moonbeam";
  Chain2["MOONRIVER"] = "moonriver";
  Chain2["PALM"] = "palm";
  Chain2["SHIDEN"] = "shiden";
  Chain2["SEI"] = "sei";
  Chain2["KINTO"] = "kinto";
  Chain2["PLUME"] = "plume";
  Chain2["ANIME"] = "anime";
  Chain2["RACE"] = "race";
  Chain2["APECHAIN"] = "apechain";
  Chain2["APEX"] = "apex";
  Chain2["BOSS"] = "boss";
  Chain2["LENS"] = "lens";
  Chain2["SONEIUM"] = "soneium";
  Chain2["GEIST"] = "geist";
  Chain2["SOCIALNETWORK"] = "socialnetwork";
  Chain2["ALCHEMYARB"] = "alchemyarb";
  Chain2["ROOTSTOCK"] = "rootstock";
  Chain2["LUMIA"] = "lumia";
  Chain2["UNICHAIN"] = "unichain";
  Chain2["SONIC"] = "sonic";
  Chain2["SPOTLIGHT"] = "spotlight";
  Chain2["XMTP"] = "xmtp";
  Chain2["CHILIZ"] = "chiliz";
  Chain2["ABSTRACT"] = "abstract";
  Chain2["K2"] = "k2";
  Chain2["METABASED"] = "metabased";
  Chain2["MONAD"] = "monad";
  Chain2["SUPERSEED"] = "superseed";
  Chain2["DEGEN"] = "degen";
  Chain2["UNITE"] = "unite";
  Chain2["INK"] = "ink";
  Chain2["SETTLUS"] = "settlus";
  Chain2["ODYSSEY"] = "odyssey";
  Chain2["RONIN"] = "ronin";
  Chain2["STANDARD"] = "standard";
  Chain2["SYNDICATE"] = "syndicate";
  Chain2["HUMANITY"] = "hunanity";
  Chain2["XPROTOCOL"] = "xprotocol";
  Chain2["ALTERSCOPE"] = "alterscope";
  Chain2["GENSYN"] = "gensyn";
  Chain2["TEA"] = "tea";
  Chain2["SPARKPOINT"] = "sparkpoint";
  Chain2["OPENLOOT"] = "openloot";
  Chain2["RISE"] = "rise";
  Chain2["BITCOIN"] = "bitcoin";
  Chain2["MARS"] = "mars";
  Chain2["EARNM"] = "earnm";
  Chain2["STORY"] = "story";
  Chain2["WYLERCHAIN"] = "wylerchain";
  Chain2["MEGAETH"] = "megaeth";
  Chain2["APTOS"] = "aptos";
  Chain2["SUI"] = "sui";
  Chain2["WORLDMOBILE"] = "worldmobile";
  Chain2["CONVERGE"] = "converge";
  Chain2["HYPERLIQUID"] = "hyperliquid";
  Chain2["V"] = "v";
  Chain2["PLASMA"] = "plasma";
  return Chain2;
}({});
const CHAIN_IDS = new Set(Object.keys(Chain));
function chainIdSchemaFactory(validator) {
  return z.string().transform(async (value, ctx) => {
    if (!await validator(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `${value} is not a ChainId`
      });
      return z.NEVER;
    }
    return value;
  });
}
__name(chainIdSchemaFactory, "chainIdSchemaFactory");
export {
  CHAIN_IDS,
  Chain,
  chainIdSchemaFactory
};
//# sourceMappingURL=chain.js.map